<template>
  <HomePage />
</template>

<script>
import HomePage from './HomePage.vue'

export default {
  name: 'HomeView',
  components: { HomePage }
}
</script>
